import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/vale-preop/Vale Pre-Op_Slider.jpg';
import projectImage2 from '../../../../assets/images/work/vale-preop/Vale Pre-Op_Slider_2.jpg';
import projectImage3 from '../../../../assets/images/work/vale-preop/Vale Pre-Op_Slider_3.jpg';
import projectImage4 from '../../../../assets/images/work/vale-preop/Vale Pre-Op_Slider_4.jpg';
import projectImage5 from '../../../../assets/images/work/vale-preop/Vale Pre-Op_Slider_5.jpg';
import projectImage6 from '../../../../assets/images/work/vale-preop/Vale Pre-Op_Slider_6.jpg';

import Data_ValePreOp from './Data_ValePreOp';

function Work_ValePreOp() {
    return (
        <>
            <DetailedHeader
                heading="Building Safer Habits Before the First Turn"
                client="Vale North Atlantic"
                service="Virtual Reality"
                date="2021"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                youtubeUrl="https://www.youtube.com/watch?v=G1HxJJAI-Os"
                images={[
                    {
                        image: projectImage1,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage2,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage3,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage4,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage5,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage6,
                        alt: 'Project Image',
                    },
                ]}
            />

            {Data_ValePreOp.content}
        </>
    );
}

export default Work_ValePreOp;
